(function ($, Drupal) {

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getFocusable(modal) {
    return modal.querySelectorAll(FOCUSABLE);
  }

  function trapFocus(e, modal) {
    var focusable = getFocusable(modal);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  function getBodyChildAncestor(el) {
    var node = el;
    while (node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
    }
    return node;
  }

  function setInert(state, modalEl) {
    var modalAncestor = getBodyChildAncestor(modalEl);
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === modalAncestor || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
      if (state) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      }
    }
  }

  function openModal($modal) {
    var modal = $modal[0];
    $modal.show();
    $('body').css('overflow', 'hidden');
    setInert(true, modal);

    requestAnimationFrame(function () {
      var focusable = getFocusable(modal);
      if (focusable.length) {
        focusable[0].focus();
      }
    });

    modal._trapHandler = function (e) { trapFocus(e, modal); };
    modal._escHandler = function (e) {
      if (e.key === 'Escape') closeModal($modal);
    };
    document.addEventListener('keydown', modal._trapHandler);
    document.addEventListener('keydown', modal._escHandler);
  }

  function closeModal($modal) {
    var modal = $modal[0];
    $modal.hide();
    $('body').css('overflow', 'visible');
    setInert(false, modal);

    if (modal._trapHandler) {
      document.removeEventListener('keydown', modal._trapHandler);
    }
    if (modal._escHandler) {
      document.removeEventListener('keydown', modal._escHandler);
    }
  }

  Drupal.behaviors.accessSite = {
    attach: function (context, settings) {
      var $accessModal = $('.modal-welcome', context);
      var isAccessible = sessionStorage.getItem('access');

      $(once('accessSite', '.modal-welcome', context)).each(function () {
        if (isAccessible !== 'yes') {
          openModal($accessModal);
        }

        $('body').on('click', '.modal-close', function (e) {
          e.preventDefault();
          closeModal($accessModal);
        });
      });

      $('body').on('click', '.modal-welcome .btn.continue', function (e) {
        e.preventDefault();
        sessionStorage.setItem('access', 'yes');
        closeModal($accessModal);
      });
    }
  };
})(jQuery, Drupal);
